export default "/images/e3b96c997c36fc6a4c73364abcd330b9.png";